export default __webpack_public_path__ + "static/media/icon_vsc.942ebbc7.png";